{
  "comment": "M10 P4b4a (plan docs/plans/2026-10-15-m10-p4b.md §3.3; hull tiers spec §4.5): the nine operator conversion kits, visual and local-only in 1.0 (off-screen strength reads the base hull). Per kit: id, display name, operator (the strategic faction id: mutual = the Mutual, raider = the Wreckers), hulls (the eligible base hulls as ships.json def ids; spec §4.5's MT-3 Tyne has no def yet, so Prize lists none until it lands), bands (the size bands its hulls may be in: S/M, rare L), agentPick (false = never picked by the agent hash: the Harpoon is the raid-scaling rule's kit, P4b6a), overlay (the local stat overlay P4b4b applies: utilityMounts added, multipliers on maxSpeed, shield, detection and repair cost; absent = 1 or 0), loadout (per eligible hull, loadout items added to the base hull's by src/ships/kits.ts applyKitLoadout; the Harpoon carries the M1 torpedo rack on each flank turret socket next to its sleds), quirk (the built-in 'mismatched parts' quirk as an M9 flaw id from hulks.json flaws), livery (the look the kitted ship wears) and namePattern (tokens {name} {hull} {kit} {tally}; P4b4b's target readout). The part GLB and its mounts stay in src/data/kit-parts.json (written by tools/blender/greybox_m10_kits.py); kits.ts joins them by operator and kit id. Every value is [P].",
  "kits": [
    {
      "id": "lifeline",
      "name": "Lifeline",
      "operator": "mutual",
      "hulls": ["hauler"],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": { "utilityMounts": 1, "repairCostMult": 0.8 },
      "loadout": {},
      "quirk": { "flaw": "slow_capacitors", "label": "Mismatched parts" },
      "livery": "mutual",
      "namePattern": "{name}, a Lifeline {hull}"
    },
    {
      "id": "pickup",
      "name": "Pickup",
      "operator": "mutual",
      "hulls": ["hauler", "miner"],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": { "utilityMounts": 1, "repairCostMult": 0.8 },
      "loadout": {},
      "quirk": { "flaw": "sticky_jets", "label": "Mismatched parts" },
      "livery": "mutual",
      "namePattern": "{name}"
    },
    {
      "id": "homestead",
      "name": "Homestead",
      "operator": "mutual",
      "hulls": ["kestrel", "hauler", "hauler_large"],
      "bands": ["S", "M", "L"],
      "agentPick": true,
      "overlay": { "utilityMounts": 1, "repairCostMult": 0.8 },
      "loadout": {},
      "quirk": { "flaw": "fused_ballast", "label": "Mismatched parts" },
      "livery": "mutual",
      "namePattern": "{name}, Homestead {hull}"
    },
    {
      "id": "neighbour",
      "name": "Neighbour",
      "operator": "mutual",
      "hulls": ["interceptor", "gunship"],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": { "utilityMounts": 1, "repairCostMult": 0.8 },
      "loadout": {},
      "quirk": { "flaw": "weak_emitters", "label": "Mismatched parts" },
      "livery": "mutual",
      "namePattern": "{name}"
    },
    {
      "id": "ram",
      "name": "Ram",
      "operator": "raider",
      "hulls": ["miner"],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": {
        "maxSpeedMult": 1.1,
        "shieldMult": 0.8,
        "detectionMult": 0.85
      },
      "loadout": {},
      "quirk": { "flaw": "buckled_frame", "label": "Mismatched parts" },
      "livery": "raider",
      "namePattern": "{tally}"
    },
    {
      "id": "runner",
      "name": "Runner",
      "operator": "raider",
      "hulls": ["meridian_courier"],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": {
        "maxSpeedMult": 1.1,
        "shieldMult": 0.8,
        "detectionMult": 0.85
      },
      "loadout": {},
      "quirk": { "flaw": "leaky_capacitors", "label": "Mismatched parts" },
      "livery": "raider",
      "namePattern": "{tally}"
    },
    {
      "id": "stripper",
      "name": "Stripper",
      "operator": "raider",
      "hulls": ["salvager", "hauler"],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": {
        "maxSpeedMult": 1.1,
        "shieldMult": 0.8,
        "detectionMult": 0.85
      },
      "loadout": {},
      "quirk": { "flaw": "sticky_jets", "label": "Mismatched parts" },
      "livery": "raider",
      "namePattern": "{tally}"
    },
    {
      "id": "prize",
      "name": "Prize",
      "operator": "raider",
      "hulls": [],
      "bands": ["S", "M"],
      "agentPick": true,
      "overlay": {
        "maxSpeedMult": 1.1,
        "shieldMult": 0.8,
        "detectionMult": 0.85
      },
      "loadout": {},
      "quirk": { "flaw": "seized_retros", "label": "Mismatched parts" },
      "livery": "raider",
      "namePattern": "{tally}"
    },
    {
      "id": "harpoon",
      "name": "Harpoon",
      "operator": "raider",
      "hulls": ["gunship"],
      "bands": ["S", "M"],
      "agentPick": false,
      "overlay": {
        "maxSpeedMult": 1.1,
        "shieldMult": 0.8,
        "detectionMult": 0.85
      },
      "loadout": {
        "gunship": [
          {
            "socket": "HP_TURRET_L",
            "weapon": "torpedo",
            "module": "hp.torpedo_rack",
            "group": "secondary",
            "slot": 0
          },
          {
            "socket": "HP_TURRET_R",
            "weapon": "torpedo",
            "module": "hp.torpedo_rack",
            "group": "secondary",
            "slot": 0
          }
        ]
      },
      "quirk": { "flaw": "misaligned_drive", "label": "Mismatched parts" },
      "livery": "raider",
      "namePattern": "{tally}"
    }
  ]
}
